import { useCallback, useEffect, useRef, useState } from 'react';
import { listUnfilledComponents } from '../services/emailAddressService';

// Keep responses tied to their account, organization and executive selection.
export default function useDashboardInbox(accountId, organizationId, executiveId, enabled = true) {
  const scope = JSON.stringify([accountId, organizationId, executiveId]);
  const currentScope = useRef(scope);
  currentScope.current = scope;
  const sequence = useRef(0);
  const [result, setResult] = useState({ scope, items: [], loading: false });
  const refresh = useCallback(async () => {
    if (!enabled || currentScope.current !== scope) return;
    const requestId = ++sequence.current;
    setResult(previous => ({ scope, items: previous.scope === scope ? previous.items : [], loading: true }));
    try {
      const data = await listUnfilledComponents(executiveId, false, true);
      if (currentScope.current === scope && sequence.current === requestId) {
        setResult({ scope, items: data.unfilled_components || [], loading: false });
      }
    } catch (error) {
      if (currentScope.current === scope && sequence.current === requestId) {
        setResult({ scope, items: [], loading: false });
      }
      console.error('Error fetching dashboard inbox:', error);
    }
  }, [scope, executiveId, enabled]);
  useEffect(() => {
    refresh();
    return () => { sequence.current += 1; };
  }, [refresh]);
  const setItems = useCallback(update => {
    if (currentScope.current !== scope) return;
    setResult(previous => {
      if (previous.scope !== scope) return previous;
      return { ...previous, items: typeof update === 'function' ? update(previous.items) : update };
    });
  }, [scope]);
  return { items: enabled && result.scope === scope ? result.items : [],
    loading: enabled && (result.scope !== scope || result.loading), refresh, setItems };
}
